export const coreBaseUrl = process.env.REACT_APP_CORE_API_URL
export const orderBaseUrl = process.env.REACT_APP_ORDERS_API_URL
export const courierBaseUrl = process.env.REACT_APP_COURIER_API_URL
export const awsAccessKey = process.env.REACT_APP_AWS_ACCESS_KEY